<template>
    <div class="pageBox">
        <div class="option">
            <el-button @click="add()">上传轮播图</el-button>
        </div>
        <div class="table" ref="table">
            <el-table element-loading-text="数据加载中..." v-loading="loading" stripe :height='height' :data="list" border>
                <el-table-column label="排序" prop="sortOrder" align="center">
                </el-table-column>
                <el-table-column label="轮播图图片" align="center">
                    <template slot-scope="scope">
                        <el-image style="width: 50px; height: 50px" :src="scope.row.imageUrl"
                            :preview-src-list="[scope.row.imageUrl]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label="是否展示" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.visible" active-color="#54a0ff" inactive-color="#cccccc"
                            @change='visibleChange($event, scope.row)'></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button @click="edit(scope.row)" type="text">编辑</el-button>
                        <el-button @click="remove(scope.row)" type="text">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="bottom">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="current"
                :page-sizes="[20, 40, 60, 80, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="轮播图" :visible.sync="dialogShow" width="30%">
            <el-form label-width="90px">
                <el-form-item label="轮播图上传">
                    <el-upload v-if="fileListLoaded && dialogShow" list-type="picture-card"
                        :on-preview="handlePictureCardPreview" :on-exceed="handleExceed" :on-remove="handleRemove"
                        :on-change="handleFileChange" :limit="1" :multiple="false" :file-list="fileList" action=""
                        :auto-upload="false">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model="form.sortOrder" placeholder="请输入排序"></el-input>
                </el-form-item>
                <el-form-item label="是否展示">
                    <el-switch v-model="form.visible" active-color="#54a0ff" inactive-color="#cccccc">
                    </el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogShow = false">关闭</el-button>
                <el-button type="primary" @click="confirm">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
import { fileRemove, fileUpload, carouselAdd, carouselEdit, carouselRemove, carouselDetail, carouselPage } from '../api.js';
export default {
    data() {
        return {
            list: [],
            total: 0,
            size: 20,
            current: 1,
            visible: null,
            height: 0,
            loading: true,
            dialogShow: false,
            dialogImageUrl: '',
            dialogVisible: false,

            form: {
                imageUrl: '',
                sortOrder: 0,
                visible: true,
            },
            fileList: [],
            fileListLoaded: false
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getElementHeight()
        })
        this.getList()
    },
    methods: {
        visibleChange(e, row) {
            this.form = {
                id: row.id,
                imageUrl: row.imageUrl || '',
                sortOrder: row.sortOrder || 0,
                visible: row.visible,
            }
            carouselEdit(this.form).then(res => {
                if (res.code === 0) {
                    this.$message({
                        duration: 1500,
                        type: 'success',
                        message: '操作成功'
                    });
                    this.getList()
                }
            })
        },
        handleFileChange(file, fileList) {
            const formData = new FormData();
            formData.append('file', file.raw);
            fileUpload(formData).then(res => {
                if (res.code === 0) {
                    this.form.imageUrl = res.data
                }
            })
        },
        handleRemove(file, fileList) {
            this.form.imageUrl = ''
            this.fileList = []
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleExceed() {
            this.$message.error('请删除后重新上传')
        },
        confirm() {
            if (this.form.id) {
                carouselEdit(this.form).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '编辑成功'
                        });
                        this.dialogShow = false
                        this.getList()
                    }
                })
            } else {
                carouselAdd(this.form).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '新增成功'
                        });
                        this.dialogShow = false
                        this.getList()
                    }
                })
            }
        },
        getList() {
            this.loading = true
            carouselPage({ current: this.current, size: this.size, visible: this.visible }).then(res => {
                if (res.code == 0) {
                    this.list = res.data.list
                    this.total = res.data.total
                    this.loading = false
                }
            })
        },
        add() {
            this.form = {
                imageUrl: '',
                sortOrder: 0,
                visible: true
            }
            this.fileList = []
            this.fileListLoaded = true;
            this.dialogShow = true
        },
        edit(row) {
            carouselDetail(row.id).then(res => {
                if (res.code === 0) {
                    this.form = {
                        id: res.data.id,
                        imageUrl: res.data.imageUrl || '',
                        sortOrder: res.data.sortOrder || 0,
                        visible: res.data.visible,
                    }
                    this.fileList = res.data.imageUrl ? [{ name: res.data.imageUrl.split('/').pop(), url: res.data.imageUrl }] : []
                    this.fileListLoaded = true;
                    this.dialogShow = true
                }
            })
        },
        remove(row) {
            this.$confirm(`确定要删除该图片吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                carouselRemove(row.id).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            duration: 1500,
                            type: 'success',
                            message: '删除成功'
                        });
                        this.getList()
                    }
                })
            }).catch(() => {
            });
        },
        handleSizeChange(val) {
            this.current = 1
            this.size = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.current = val
            this.getList()
        },
        getElementHeight() {
            const container = this.$refs.table;
            if (container) {
                this.height = container.offsetHeight
            }
        },
    }
}
</script>
<style scoped lang="less">
.pageBox {
    width: 100%;
    height: 100%;
    padding: 20px 50px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .option {
        margin-bottom: 20px;
        display: flex;
        justify-content: flex-end;
    }

    .table {
        flex: 1;
    }

    .bottom {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>